const DONATE_URL = 'https://e001e9ac-68a7-4c40-b8ea-95640b3298a4.paylinks.godaddy.com/5d21dd81-b1d5-4b22-8cd2-c45';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-heart-fill text-white w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-2xl font-bold text-white" style={{ fontFamily: '"Inter", sans-serif' }}>
                El Dorado Cat Rescue
              </span>
            </div>
            <p className="text-gray-300 mb-4">
              Dedicated to rescuing, rehabilitating, and rehoming cats in El Dorado County. 
              Every cat deserves a loving home.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
                <span>El Dorado County, California</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                <span>(530) 555-CATS</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                <span>info@eldoradocatrescue.org</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="/adoption" className="block text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                Adopt a Cat
              </a>
              <a
                href={DONATE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
              >
                Make a Donation
              </a>
              <a href="/contact" className="block text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                Contact Us
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 El Dorado Cat Rescue. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="text-orange-400 hover:text-orange-300 ml-1 cursor-pointer">
              AI Consulting Authority
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}